export default {
  switchLabel: {
    margin: 6,
    width: 24
  },
  tableRadioGroup: {
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  tableRadioLabel: {
    marginRight: 0
  },
  tableWidth: {
    width: 918
  }
}
